import messages from '../../../../../translations/messages_front.fr.json';
import validators from '../../../../../translations/validators.fr.json';

export const translations = {
  messages: messages as Record<string, string>,
  validators: validators as Record<string, string>,
};
